import { render, staticRenderFns } from "./LabelIndicator.vue?vue&type=template&id=031e607c"
import script from "./LabelIndicator.vue?vue&type=script&lang=js"
export * from "./LabelIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports